import { AppState } from '../../../store/App.reducer'
import { UtilisateurPrestataire } from '../interfaces/utilisateur.interface'

export const selectUtilisateurPrestataire = (state: AppState): UtilisateurPrestataire[] => state.utilisateur.prestataires
